export default __webpack_public_path__ + "static/media/398.2c75e518.jpg";